import React, { useState } from 'react';
import { Step } from '../../../components/general/stepper/step/step';
import { Stepper } from '../../../components/general/stepper/stepper';
import { useStepperConnector } from '../../../components/general/stepper/use-stepper-connector';
import { DetailsStep } from './details-step/details-step';
import { SkillsStep } from './skills-step/skills-step';
import SummaryStep from './summary-step/summary-step';
import { GetSkillCategoryResponse } from '../../../overmind/actions';

enum StepIds {
  Details = 'Details',
  Skills = 'Skills',
  Summary = 'Summary',
}

export function SkillCategoriesWizard({ skillCategory, setSkillCategory }: { skillCategory: GetSkillCategoryResponse | undefined; setSkillCategory: (skillCategory: GetSkillCategoryResponse) => void }): React.ReactElement {
  const [isLoading] = useState<boolean>(false);
  // const [skillCategory, setSkillCategory] = useState<GetSkillCategoryResponse>();

  // useEffect(() => {
  //   setSkillCategory(initialSkillCategory);
  // }, [initialSkillCategory]);

  const stepperConnector = useStepperConnector();

  return (
    <Stepper {...stepperConnector}>
      <Step key={StepIds.Details} label={StepIds.Details} completed={!!skillCategory?.slug} required>
        <DetailsStep
          parentIsLoading={isLoading}
          skillCategory={skillCategory}
          onNext={skillCategory => {
            setSkillCategory(skillCategory);
            stepperConnector.next();
          }}
        />
      </Step>

      <Step key={StepIds.Skills} label={StepIds.Skills} completed={!!skillCategory?.skills.length} required>
        <SkillsStep
          parentIsLoading={isLoading}
          skillCategory={skillCategory}
          onBack={stepperConnector.previous}
          onNext={skillCategory => {
            setSkillCategory(skillCategory);
            stepperConnector.next();
          }}
        />
      </Step>

      <Step key={StepIds.Summary} label={StepIds.Summary} required>
        <SummaryStep skillCategory={skillCategory} goToStep={stepperConnector.goTo} onBack={stepperConnector.previous} />
      </Step>
    </Stepper>
  );
}
